module.exports = __webpack_public_path__ + "img/instagramWhite.6a6334eb.png";